import { cloneDeep, findIndex, reduce } from 'lodash';
import { PropertyType } from '../../../common';
import { TreeValueType } from 'esa-ui-library/lib/types';

export const getActiveLabels = (options: PropertyType[]): string[] => {
	const sortedOptions = options?.sort((a, b) => {
		const idxA = a.idx ?? Infinity;
		const idxB = b.idx ?? Infinity;
		return idxA - idxB;
	});
	const active = sortedOptions?.reduce((acc: string[], item: PropertyType) => {
		if (item.isChecked) {
			acc.push(item.label);
		}
		return acc;
	}, []);
	return active || [];
};

export const getUpdateOptions = (option: PropertyType, options: PropertyType[]): PropertyType[] => {
	const state = cloneDeep(options);
	const optionIndex = findIndex(state, ['value', option.value]);
	if (optionIndex !== -1) {
		const currentStatus = Boolean(state[optionIndex]?.isChecked);
		state[optionIndex].isChecked = !currentStatus;
	}
	return state;
};

export const getFilterValue = (options: PropertyType[], field = 'value'): string => {
	const sortedOptions = options.sort((a, b) => {
		const idxA = a.idx ?? Infinity;
		const idxB = b.idx ?? Infinity;
		return idxA - idxB;
	});

	const result = reduce(
		sortedOptions,
		(acc, item) => {
			if (item.isChecked) {
				acc += `${item[field]},`;
			}

			return acc;
		},
		''
	);
	return result.slice(0, -1);
};

export const selectPreselectedOptions = (
	options: PropertyType[],
	selected: string,
	field = 'value'
): PropertyType[] => {
	if (!options) return [];
	const filters = selected.split(',');

	let maxIdx = -1;
	options.forEach((option) => {
		if (option.idx !== undefined && option.idx !== null) {
			maxIdx = Math.max(maxIdx, option.idx);
		}
	});

	++maxIdx;
	const result = options.map((option) => {
		const newOption: PropertyType = { ...option };
		const value = option[field]?.toString() || '';
		if (filters.includes(value)) {
			if (!newOption.isChecked) {
				newOption.idx = maxIdx++;
			}
			newOption.isChecked = true;
		} else {
			newOption.isChecked = false;
			newOption.idx = undefined;
		}
		return newOption;
	});

	return result;
};

export const selectPreselectedPartnersOptions = (options: TreeValueType[], selected: string): TreeValueType[] => {
	const filters = selected.split(',');
	const result: TreeValueType[] = [];

	const processOption = (option: TreeValueType): TreeValueType => {
		const newOption: TreeValueType = { ...option };
		if (filters.includes(option.value.toString())) {
			result.push(newOption);
		}
		if (option.options && Array.isArray(option.options)) {
			newOption.options = option.options.map(processOption);
		}
		return newOption;
	};

	options.forEach(processOption);

	return result;
};
